<script setup>
import { useAdmin } from 'dashboard/composables/useAdmin';
import { computed } from 'vue';
import StatusChip from './ui/StatusChip.vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  channelId: {
    type: Number,
    required: true,
  },
  template: {
    type: Object,
    default: () => {
      return { name: '', status: '', category: '', language: '' };
    },
  },
});

const emit = defineEmits(['openDelete']);

const { t } = useI18n();

const { isAdmin } = useAdmin();

const status = computed(() => {
  switch (props.template.status) {
    case 'REJECTED':
      return { text: t('WHATSAPP_TEMPLATES.STATUS.REJECTED'), type: 'danger' };
    case 'PENDING':
      return { text: t('WHATSAPP_TEMPLATES.STATUS.PENDING'), type: 'warning' };
    case 'APPROVED':
      return { text: t('WHATSAPP_TEMPLATES.STATUS.APPROVED'), type: 'success' };
    default:
      return { text: t('WHATSAPP_TEMPLATES.STATUS.UNKNOW'), type: 'danger' };
  }
});

const language = computed(() => {
  return t(`WHATSAPP_TEMPLATES.LANGUAGES.${props.template.language}`);
});

const category = computed(() => {
  return t(`WHATSAPP_TEMPLATES.CATEGORIES.${props.template.category}`);
});

const HandleDelete = () => {
  emit('openDelete', props.template);
};
</script>

<template>
  <tr>
    <!-- Template Name -->
    <td class="px-4 py-4 text-left">
      <p class="text-slate-700 dark:text-slate-100">{{ template.name }}</p>
    </td>

    <!-- Category -->
    <td class="px-4 py-4 text-left">
      <p class="text-slate-700 dark:text-slate-100">{{ category }}</p>
    </td>

    <!-- Language -->
    <td class="px-4 py-4 text-left">
      <p class="text-slate-700 dark:text-slate-100">{{ language }}</p>
    </td>

    <!-- Status -->
    <td class="px-4 py-4 text-left">
      <StatusChip :type="status.type" :text="status.text" />
    </td>

    <!-- Actions -->
    <td class="px-4 py-4 text-right">
      <div class="flex gap-1 justify-end">
        <!-- <router-link
          :to="{
            name: 'settings_inbox_update_message_template',
            params: { template_name: template.name, channel_id: channelId },
          }"
        >
          <woot-button
            v-if="isAdmin"
            v-tooltip.top="$t('INBOX_MGMT.SETTINGS')"
            variant="smooth"
            size="tiny"
            icon="settings"
            color-scheme="secondary"
            class-names="grey-btn"
          />
        </router-link> -->
        <woot-button
          v-if="isAdmin"
          v-tooltip.top="$t('INBOX_MGMT.DELETE.BUTTON_TEXT')"
          variant="smooth"
          color-scheme="alert"
          size="tiny"
          class-names="grey-btn"
          icon="dismiss-circle"
          @click="HandleDelete"
        />
      </div>
    </td>
  </tr>
</template>
